import React, { useState, useEffect } from 'react';
import ExploreAllCard from "./Explorecard";
import ModalImage from "./ModalImage";
import {  Women_Sets, Women_Shirts_Tops } from "../data/products";

function WomenSetSelect() {
  const getUniqueById = (arr) => [
    ...new Map(arr.map((item) => [item.id, item])).values(),
  ];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const handleOpenModal = (id, allItems) => {
    const filtered = allItems.filter((item) => item.id === id);
    setSelectedImages(filtered);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);
  return (
    <div>
      <div className="content">
        <h2 className="Explore-h2">Women_Sets Collections</h2>

        <section className="categories section-offwhite">
          {/* <h2>Women Sets</h2> */}
          <div className="categories__list">
            {getUniqueById(Women_Sets).map((ExploreAll) => (
              <ExploreAllCard
                key={`women-sets-${ExploreAll.id}`}
                ExploreAll={ExploreAll}
                allItems={Women_Sets}
                onImageClick={handleOpenModal}
              />
            ))}

            {getUniqueById(Women_Shirts_Tops).map((ExploreAll) => (
              <ExploreAllCard
                key={`women-tops-${ExploreAll.id}`}
                ExploreAll={ExploreAll}
                allItems={Women_Shirts_Tops}
                onImageClick={handleOpenModal}
              />
            ))}
          </div>
        </section>
        {isModalOpen && (
          <ModalImage
            images={selectedImages}
            handleCloseModal={handleCloseModal}
          />
        )}
        {/* 
        <section className="categories section-offwhite">
          <h2>Women Shirts:Tops</h2>
          <div className="categories__list">
            {Women_Shirts_Tops.map((ExploreAll) => (
              <ExploreAllCard key={ExploreAll.id} ExploreAll={ExploreAll} />
            ))}
          </div>
        </section> */}
      </div>
    </div>
  );
}

export default WomenSetSelect;
